/**
 * @file Helper for reading campaign source code from cookies.
 */

/**
 * Retrieves the campaign source code from the campaign cookie only.
 *
 * @returns The campaign source code from cookie, or empty string if not found.
 */
export function getCampaignSourceCode(): string {
  return getCookieValue("campaign") || "";
}

/**
 * Retrieves a cookie value by name.
 *
 * @param name - The name of the cookie to retrieve.
 * @returns The value of the cookie, or null if the cookie is not found.
 */
function getCookieValue(name: string): string | null {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) {
    const cookieValue = parts.pop()?.split(";").shift();
    return cookieValue || null;
  }
  return null;
}
